import {ModuleWithProviders, NgModule, Optional, SkipSelf} from '@angular/core';
import {CommonModule} from '@angular/common';
import {StoreModule} from '@ngrx/store';
import {reducers} from './reducers';
import {TokenService} from './services/token.service';
import {EffectsModule} from '@ngrx/effects';
import {OrganizationTokenEffects} from './effects/organization-token.effects';
import {UserService} from './services/user.service';
import {UserEffects} from './effects/user.effects';
import {OrganizationUserService} from './services/organization-user.service';
import {OrganizationUserEffects} from './effects/organization-user.effects';
import {DeviceEffects} from './effects/device.effects';
import {DeviceService} from './services/device.service';
import {AirDataService} from './services/air-data.service';
import {AirDataPollEffects} from './effects/air-data-poll.effects';
import {FloorPlanEffects} from './effects/floor-plan-effects';
import {FloorPlanService} from './services/floor-plan.service';
import {AirnoteService} from './services/airnote.service';
import {GroupUserService} from './services/group-user.service';

@NgModule({
  imports: [CommonModule]
})
export class AfbApiModule {
  static forRoot(): ModuleWithProviders {
    return {
      ngModule: AfbApiModule,
      providers: [
        TokenService,
        UserService,
        DeviceService,
        OrganizationUserService,
        AirDataService,
        FloorPlanService,
        AirnoteService,
        GroupUserService
      ]
    }
  }
  static forRootWithState(): ModuleWithProviders {
    return {
      ngModule: AfbApiWithStateModule,
      providers: [
        TokenService,
        UserService,
        DeviceService,
        OrganizationUserService,
        AirDataService,
        FloorPlanService,
        AirnoteService,
        GroupUserService
      ]
    }
  }

  // Skips if AfbApiModule is being loaded in module other than AppModule
  constructor( @Optional() @SkipSelf() parentModule: AfbApiModule) {
    if (parentModule) {
      throw new Error('AfbApiModule is already loaded');
    }
  }
}

@NgModule({
  imports: [
    StoreModule.forFeature('afbApi', reducers),
    EffectsModule.forFeature([
      UserEffects,
      DeviceEffects,
      OrganizationTokenEffects,
      OrganizationUserEffects,
      AirDataPollEffects,
      FloorPlanEffects
    ])
  ]
})
export class AfbApiWithStateModule {
  constructor( @Optional() @SkipSelf() parentModule: AfbApiWithStateModule) {
    if (parentModule) {
      throw new Error('AfbApiModule is already loaded');
    }
  }
}

